import React, { MouseEventHandler, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

import "./button.css";

export interface ButtonProps {
  title: string;
  type?: "primary" | "secondary";
  className?: string;
  onClick?: MouseEventHandler;
  icon?: string;
  circle?: boolean;
  disabled?: boolean;
}

export const Button = ({
  title,
  type,
  className,
  onClick,
  icon,
  circle,
  disabled,
}: ButtonProps) => {
  const isPrimary = useMemo(() => !type || type === "primary", [type]);
  const isSecondary = useMemo(() => type === "secondary", [type]);

  const buttonClassName = useMemo(
    () =>
      classNames({
        "xvia-button": true,
        "xvia-button---primary": isPrimary,
        "xvia-button---secondary": isSecondary,
        "xvia-button---circle": circle,
        [className as string]: !!className,
      }),
    [isPrimary, isSecondary, className, circle]
  );
  return (
    <button className={buttonClassName} onClick={onClick} disabled={disabled}>
      {icon ? (
        <FontAwesomeIcon width={16} height={16} icon={icon as IconProp} />
      ) : null}
      {!!title && <span style={{ marginLeft: !!icon ? 8 : 0 }}>{title}</span>}
    </button>
  );
};
